export default __webpack_public_path__ + "static/media/assign_Transfer_job_white.3d7dd1c5.svg";